'use client';

import { useAtomValue } from 'jotai';

import { Typography } from '@gds/Typography/Typography';

import { latestNlsQueryAtom } from './Atoms/LatestNlsQuery.atom';
import { SearchInfoToggle } from './Components/SearchInfoModal/SearchInfoToggle';

type Props = {
  plpHeader: string;
  nlHeader: string;
};

export const NaturalLanguageSearchHeader = ({ plpHeader, nlHeader }: Props) => {
  const latestNlsQuery = useAtomValue(latestNlsQueryAtom);

  return (
    <>
      <Typography variant={'h4'} Component="h1">
        {latestNlsQuery ? (
          <>
            {nlHeader} "<span color="grey">{latestNlsQuery}</span>"
          </>
        ) : (
          plpHeader
        )}
      </Typography>
      {latestNlsQuery && <SearchInfoToggle />}
    </>
  );
};
